let actions = [];

let update = function() {
  actions.forEach((fn) => {
    fn.call();
  });
};

let add = function(fn) {
  actions.push(fn);

  return fn;
};

export default {
  add: add,
  update: update
};
